import * as React from 'react';
import { CONTENT_MAX_WIDTH } from '../constants';
import SectionBreak from '../../../../ui/SectionBreak';
import FaqSection from './FaqSection';
import emailSubjectAndBodyQueryParams from '../../../../../utils/email';
import {
  minglQrStickerSubject,
  minglQrStickersBody,
  minglCustomURLSubject,
  minglCustomURLBody,
} from '../../../../../utils/PreWrittenEmail';

interface Props {
  contentMaxWidth?: string;
}

export default function FrequentlyAskedQuestions({
  contentMaxWidth = CONTENT_MAX_WIDTH,
}: Props) {
  return (
    <div className="bg-white">
      <div className="pa5 pb6 center" style={{ maxWidth: contentMaxWidth }}>
        <h2 className="mingl-black mt0 ">Frequently Asked Questions </h2>
        <SectionBreak width={2} length="0" />
        <FaqSection
          question="I met a person without Mingl. What now?"
          answer={
            <span>
              You can share your Mingl with any smartphone. They don’t even need
              the Mingl app. Did you know that QR codes are scannable by all
              iPhone cameras? On Android they can use the Google assistant, any
              QR scanner, or go to{' '}
              <a className="linkStyle" href="https://mingl.no/qr">
                mingl.no/qr
              </a>{' '}
              to use our custom built web scanner. You can also choose to share
              in many other ways. Just click the share icon to see the other
              options. 🤗
            </span>
          }
        />
        <SectionBreak width={2} length="0" />
        <FaqSection
          question="How do I share my colleague or friend’s contact information?"
          answer={
            <span>
              Find their card and click the share icon. Now you can share it in
              all the same ways as you can share your own card!
            </span>
          }
        />
        <SectionBreak width={2} length="0" />
        <FaqSection
          question="I've met people with QR stickers, how can I get my own?"
          answer={
            <span>
              We make QR stickers you can put on the back of your phone or
              wherever, to make it even faster to share your info. Simply email
              your adress to{' '}
              <a
                href={`mailto:contact@mingl.no${emailSubjectAndBodyQueryParams(
                  minglQrStickerSubject,
                  minglQrStickersBody
                )}`}
                className="linkStyle"
              >
                contact@mingl.no
              </a>{' '}
              and we&apos;ll mail it to you. 🥳
            </span>
          }
        />
        <SectionBreak width={2} length="0" />
        <FaqSection
          question="Is it possible to get a customized link?"
          answer={
            <span>
              A customized link (URL) could look like mingl.no/YourName. Please
              email your desired username to{' '}
              <a
                className="linkStyle"
                href={`mailto:contact@mingl.no${emailSubjectAndBodyQueryParams(
                  minglCustomURLSubject,
                  minglCustomURLBody
                )}`}
              >
                contact@mingl.no
              </a>{' '}
              and we&apos;ll see if we can accommodate your request.
            </span>
          }
        />
        <SectionBreak width={2} length="0" />
        <FaqSection
          question="How do I share with Android users?"
          answer={
            <span>
              Any QR reader can scan your card. If they don&apos;t have one, go
              to{' '}
              <a href="https://www.mingl.no/qr" className="linkStyle">
                mingl.no/qr
              </a>{' '}
              to use our web QR scanner. <br /> Did you know that Google Lens
              can scan QR codes?
            </span>
          }
        />
        <SectionBreak width={2} length="0" />
      </div>
    </div>
  );
}
